import {
  GoogleMap,
  LoadScript,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";
import { serviceKeys } from "../../constants";
import map_pin from "../../assets/map_pin.png";
import { useTranslation } from "react-i18next";
const containerStyle = {
  width: "100%",
  height: "200px",
};
export default function MapSection({ event }) {
  const { t } = useTranslation();
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: serviceKeys.API_KEY,
  });

  if (!isLoaded) {
    return (
      <div className="bg-[#05261c] border border-green-900/30 rounded-xl h-[200px] flex items-center justify-center">
        <p className="text-green-400">{t("map.loading")}</p>
      </div>
    );
  }

  const defaultCoordinates = {
    lat: 40.4168,
    lng: -3.7038,
  };

  const hasCoords =
    event?.map_latitude !== null &&
    event?.map_latitude !== undefined &&
    event?.map_longitude !== null &&
    event?.map_longitude !== undefined;

  const coordinates = hasCoords
    ? {
        lat: Number(event.map_latitude),
        lng: Number(event.map_longitude),
      }
    : defaultCoordinates;

  return (
    <div className="bg-[#05261c] border border-green-900/30 rounded-xl overflow-hidden">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={coordinates}
        zoom={14}
        options={{
          disableDefaultUI: true,
          zoomControl: true,
        }}
      >
        {hasCoords && (
          <Marker
            position={coordinates}
            icon={{
              url: map_pin, 
              scaledSize: new window.google.maps.Size(60, 60),
            }}
          />
        )}
      </GoogleMap>

      {/* <LoadScript googleMapsApiKey={serviceKeys.API_KEY}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={coordinates}
          zoom={14}
          options={{
            disableDefaultUI: true,
            zoomControl: true,
          }}
        >
          <Marker
            position={coordinates}
            icon={{
              url: map_pin,
              scaledSize: new window.google.maps.Size(60, 60),
            }}
          />
        </GoogleMap>
      </LoadScript> */}
    </div>
  );
}
